import { useEffect, useState } from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash as iconTrash,
  faPlus as iconPlus,
} from '@fortawesome/free-solid-svg-icons';
import { Participant } from '../../models';

type MultiParticipantProps = {
  onChange: Function;
  isInvalid: boolean;
  [x: string]: any;
}

export default function MultiParticipant({ onChange = () => null, isInvalid = false }: MultiParticipantProps) {
  const [participants, setParticipants] = useState<Participant[]>([]);
  const [participantFirstName, setParticipantFirstName] = useState<string | null>(null);
  const [participantLastName, setParticipantLastName] = useState<string | null>(null);
  const [errors, setErrors] = useState({
    participantFirstName: isInvalid,
    participantLastName: isInvalid
  });

  useEffect(() => {
    setErrors({
      participantFirstName: isInvalid,
      participantLastName: isInvalid
    });
  }, [isInvalid]);

  const resetValues = () => {
    setParticipantFirstName(null);
    setParticipantLastName(null);
    setErrors({
      participantFirstName: isInvalid,
      participantLastName: isInvalid
    });
  };

  const onAddParticipant = () => {
    if (participantFirstName && participantLastName) {
      const updatedParticipants = [...participants, {
        participantFirstName: participantFirstName || '',
        participantLastName: participantLastName || '',
      }];

      setParticipants(updatedParticipants);
      onChange(updatedParticipants);
      resetValues();
    } else {
      setErrors({
        participantFirstName: !participantFirstName || isInvalid,
        participantLastName: !participantLastName || isInvalid
      });
    }
  };

  const removeParticipant = (index: number) => {
    const updatedParticipants = [...participants];
    updatedParticipants.splice(index, 1);
    setParticipants(updatedParticipants);
    onChange(updatedParticipants);
  };

  const disabled = !participantFirstName || !participantLastName || participants.length === 3;

  return (
    <div id="schedule-claim-booking-participant-container">
      <span className="fw-light text-danger fst-italic ms-2 text-small">
        You can add up to 3 participants.
      </span>
      <Form.Group className="mb-3 d-flex flex-row flex-wrap row">
        <Col sm={5}>
          <Form.Group controlId="participantFirstName" className="mt-3">
            <Form.Label>Participant First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="First Name"
              value={participantFirstName || ''}
              onKeyPress={(e) => {
                e.key === 'Enter' && onAddParticipant();
              }}
              onChange={(e) => setParticipantFirstName(e.target.value)}
              isInvalid={errors.participantFirstName}
              disabled={participants.length === 3}
            />
            <Form.Control.Feedback type="invalid">
              First Name is required.
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm={5}>
          <Form.Group controlId="participantLastName" className="mt-3">
            <Form.Label>Participant Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Last Name"
              value={participantLastName || ''}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  onAddParticipant();
                }
              }}
              onChange={(e) => setParticipantLastName(e.target.value)}
              isInvalid={errors.participantLastName}
              disabled={participants.length === 3}
            />
            <Form.Control.Feedback type="invalid">
              Last Name is required.
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm={2} className="mt-auto pt-2">
          <Button
            variant="success"
            onClick={onAddParticipant}
            disabled={disabled}>
            <FontAwesomeIcon icon={iconPlus} />
          </Button>
        </Col>
      </Form.Group>
      {participants.length > 0 &&
        <div className="mb-4">
          {participants.map((participant: Participant, index: number) => (
            <div key={index} className={`d-flex align-content-center px-2 py-2 text-white bg-gradient ${index % 2 ? 'bg-danger' : 'bg-secondary'}`}>
              <div className="flex-grow-1 align-self-center">
                {participant.participantFirstName} {participant.participantLastName}
              </div>
              <div className="flex-shrink-1">
                <button
                  onClick={() => removeParticipant(index)}
                  style={{
                    background: 'none',
                    border: 'none',
                  }}
                  className="text-white"
                >
                  <FontAwesomeIcon icon={iconTrash} />
                </button>
              </div>
            </div>
          ))}
        </div>
      }
    </div >
  );
}